import script from "./RevenuesChart.vue?vue&type=script&setup=true&lang=js"
export * from "./RevenuesChart.vue?vue&type=script&setup=true&lang=js"

import "./RevenuesChart.vue?vue&type=style&index=0&id=6d32c6a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d32c6a4"]])

export default __exports__